import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

import { AuthProvider } from "@/context/AuthContext";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import LeadsManager from "@/pages/admin/LeadsManager";
import MediaLibrary from "@/pages/admin/MediaLibrary";
import HeroEditor from "@/pages/admin/HeroEditor";
import ServicesEditor from "@/pages/admin/ServicesEditor";
import GalleryEditor from "@/pages/admin/GalleryEditor";
import AboutEditor from "@/pages/admin/AboutEditor";
import SettingsEditor from "@/pages/admin/SettingsEditor";
import AdminHelp from "@/pages/admin/AdminHelp";
import UsersManager from "@/pages/admin/UsersManager";
import PagesManager from "@/pages/admin/PagesManager";
import PageEditor from "@/pages/admin/PageEditor";
import NavigationEditor from "@/pages/admin/NavigationEditor";
import DynamicPage from "@/pages/DynamicPage";
import AcceptInvite from "@/pages/auth/AcceptInvite";

function ScrollToTop() {
  const { pathname, hash } = window.location;
  React.useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function PublicSite() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<Navigate to="/" replace />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/pages/:slug" element={<DynamicPage />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            {/* Admin routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/accept-invite/:token" element={<AcceptInvite />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="leads" element={<LeadsManager />} />
              <Route path="media" element={<MediaLibrary />} />
              <Route path="hero" element={<HeroEditor />} />
              <Route path="services" element={<ServicesEditor />} />
              <Route path="gallery" element={<GalleryEditor />} />
              <Route path="about" element={<AboutEditor />} />
              <Route path="settings" element={<SettingsEditor />} />
              <Route path="users" element={<UsersManager />} />
              <Route path="pages" element={<PagesManager />} />
              <Route path="pages/:id" element={<PageEditor />} />
              <Route path="navigation" element={<NavigationEditor />} />
              <Route path="help" element={<AdminHelp />} />
            </Route>

            {/* Public site */}
            <Route path="/*" element={<PublicSite />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
